module.exports = __webpack_public_path__ + "voxeet-worklet.js";
